// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"405":"19618e0d","613":"37046a57","981":"19618e0d"}[chunkId] + ".chunk.css";
};